'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var locale = require('./constants/locale.js');
var restrictedExtensions = require('./constants/restricted-extensions.js');
var locale$1 = require('./enums/locale.js');
var accessibility = require('./accessibility/accessibility.js');
var date = require('./localize/date.js');
var dateTime = require('./localize/date-time.js');
var percentage = require('./localize/percentage.js');
var size = require('./localize/size.js');
var sanitize = require('./sanitize/sanitize.js');
var slugify = require('./slugify/slugify.js');
var year = require('./time/year.js');
var booleanish = require('./truthy/booleanish.js');
var previewType = require('./content/preview-type.js');
var whitelabel = require('./whitelabel/whitelabel.js');
var removeFileExtension = require('./asset/remove-file-extension.js');



exports.DEFAULT_ISO_LANGUAGE_REGION = locale.DEFAULT_ISO_LANGUAGE_REGION;
exports.RESTRICTED_EXTENSIONS = restrictedExtensions.RESTRICTED_EXTENSIONS;
Object.defineProperty(exports, "IsoLanguagesRegions", {
	enumerable: true,
	get: function () { return locale$1.IsoLanguagesRegions; }
});
exports.keyPressHelper = accessibility.keyPressHelper;
exports.localizeDate = date.localizeDate;
exports.localizeDateTime = dateTime.localizeDateTime;
exports.localizePercentage = percentage.localizePercentage;
exports.localizeFileSize = size.localizeFileSize;
exports.sanitize = sanitize.sanitize;
exports.slugify = slugify.slugify;
exports.getCurrentYear = year.getCurrentYear;
exports.getBooleanishTruthy = booleanish.getBooleanishTruthy;
exports.isVideoPreviewType = previewType.isVideoPreviewType;
exports.whitelabelPresenter = whitelabel.whitelabelPresenter;
exports.removeFileExtension = removeFileExtension.removeFileExtension;
//# sourceMappingURL=index.js.map
